import React, { Component } from "react";

export default class ProjectCard extends Component {
    render() {
        const { title, desc, live, date, image } = this.props.project;
        if (!this.props.project) {
            return <div className="my-3 grad">Loading...</div>;
        }
        return (
            <a href={live} target="_blank" rel="noreferrer" className="rounded-lg">
                <div className="projectCard">
                    <img
                        src={image}
                        className="d-block w-100 rounded"
                        alt="project-pic"
                    />
                    <div className="profession mt-3">{title}</div>
                    <div className="edu-title">{desc}</div>
                    <div className="small date text-right mt-2">{date}</div>
                </div>
            </a>
        );
    }
}
